<template>
  <div class="container page lottery-page">
    <van-nav-bar :title="lottery.name" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back" />
      </template>
    </van-nav-bar>

    <div class="page-body">
      <div class="hero-wrap">
        <section class="hero-card" >
          <div class="hero-top">
            <div>
              <p class="hero-status">{{ $t("reservation.voting_results") }}</p>
              <p class="hero-expect">{{ lottery.now_expect }}</p>
            </div>
            <div class="hero-menu" @click="showRight">
              <van-icon name="apps-o" />
            </div>
          </div>

          <div class="hero-countdown">
            <van-count-down :time="time" @finish="check" />
          </div>

          <div class="hero-bottom">
            <div class="hero-result">
              <span class="hero-label">{{ lottery.now_expect }}</span>
              <span class="hero-result-title">{{ $t("reservation.voting_results") }}</span>
            </div>
            <div class="hero-history-toggle" @click="active = !active">
              <span>{{ historyToggleText }}</span>
              <van-icon name="arrow-down" :class="{ up: active, down: !active }" />
            </div>
          </div>
        </section>

        <transition name="history-drop">
          <section v-if="active" class="history-dropdown">
            <div class="history-head">
              <span>{{ $t("reservation.num") }}</span>
              <span>{{ $t("reservation.win_num") }}</span>
            </div>
            <div class="history-list">
              <div v-for="(item, index) in lottery_list" :key="index" class="history-item">
                <span class="history-expect">{{ item.expect }}</span>
                <span class="history-result">{{ formatHistoryResult(item) }}</span>
              </div>
            </div>
          </section>
        </transition>

        <transition name="mask-fade">
          <div v-if="active" class="page-mask" @click="active = false"></div>
        </transition>
      </div>

      <section class="section-block">
        <div class="section-title">{{ uiText.optionTitle }}</div>
        <div class="option-grid">
          <div
              v-for="card in optionCards"
              :key="card.type"
              class="option-card"
              :class="{ active: choose[card.type] }"
              @click="choosePlay(card.type, card.name)"
          >
            <div class="option-icon">{{ card.icon }}</div>
            <div class="option-name">{{ card.label }}</div>
            <!--            <div class="option-odd">{{ card.proportion }}</div>-->
          </div>
        </div>
      </section>

      <section class="live-board">
        <div class="live-header">{{ liveBoardTitle }}</div>
        <div class="live-content">
          <div
              class="live-track"
              :class="{ scrolling: liveFeedRows.length > 1 }"
              :style="liveTrackStyle"
          >
            <div v-for="(item, index) in liveFeedLoopRows" :key="`${item}-${index}`" class="live-row">
              {{ item }}
            </div>
          </div>
        </div>
      </section>

    </div>

    <div v-show="hasSelection" class="bottom-sheet">
      <div class="selection-summary">{{ sheetSummaryText }}</div>
      <div class="sheet-panel">
        <div class="sheet-row">
          <span class="sheet-label">{{ pointText }}</span>
          <div class="sheet-input-wrap">
            <div class="sheet-input">
              <van-field
                  v-model="money"
                  type="digit"
                  :placeholder="$t('reservation.price_place')"
              />
            </div>
            <div class="sheet-unit-pill">{{ sheetPillText }}</div>
          </div>
        </div>
      </div>
      <div class="bottom-submit" @click="jiesuan">{{ $t("reservation.submit") }}</div>
    </div>

    <van-popup v-model="jiesuanpage" get-container="body" round class="confirm-popup">
      <div class="confirm-order-modal">
        <div class="head">
          <p class="text">{{ $t("reservation.task_list") }}</p>
        </div>
        <ul class="list">
          <li
              v-for="(v, key) in formData"
              :key="key"
              class="lise-item van-hairline--bottom"
          >
            <div class="main">
              <p class="bet-name">{{ getDisplayName(v.name) }}</p>
              <p class="detail-text">
                1{{ $t("reservation.note") }}X{{ money }}({{ $t("reservation.unit") }})={{ money }}({{ $t("reservation.unit") }})
              </p>
            </div>
            <van-icon @click="clearChooes(v.type)" name="close" />
          </li>
        </ul>
        <div class="sub-bar">
          <van-button class="item cancel-btn" type="default" @click="allClear">
            {{ $t("reservation.clear_order") }}
          </van-button>
          <van-button class="item sub-btn" type="default" @click="doSub">
            {{ $t("reservation.submit") }}
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="showModel" position="right" class="menu-popup">
      <div class="menu-list">
        <div
            v-for="(i, index) in gameitemData"
            :key="index"
            class="menu-item"
            @click="tabList(i.id, i.key)"
        >
          <div class="menu-tag">{{ uiText.linkedActivity }}</div>
          <div class="menu-card">
            <van-image width="56" height="56" :src="i.ico" />
          </div>
          <div class="menu-name">{{ i.name }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
var time;
var count = 0;

export default {
  data() {
    return {
      jiesuanpage: false,
      showModel: false,
      rose: "",
      lily: "",
      balloon: "",
      fireworks: "",
      choose: {
        big: false,
        small: false,
        one: false,
        two: false,
        "3": false,
        "4": false,
        "5": false,
        "6": false,
        "7": false,
        "8": false,
        "9": false,
        "10": false,
        "11": false,
        "12": false,
        "13": false,
        "14": false,
        "15": false,
        "16": false,
        "17": false,
        "18": false,
      },
      shopping: false,
      isLoading: false,
      lottery_peilv_list: [],
      lottery_list: [],
      active: false,
      userInfo: {},
      lottery: {},
      sum: 0,
      size: "",
      double: "",
      time: 0,
      shopchoose: "",
      gameitem: "",
      formData: [],
      money: "",
      ids: this.$route.query.id,
      keys: this.$route.query.key,
      gameitemData: [],
    };
  },
  computed: {
    convertedShopchoose() {
      const mapping = {
        big: this.rose,
        small: this.lily,
        one: this.fireworks,
        two: this.balloon,
      };

      return (this.shopchoose || "")
          .split(",")
          .filter(Boolean)
          .map((keyword) => mapping[keyword] || mapping[this.getTypeByName(keyword)] || keyword)
          .join("、");
    },
    optionCards() {
      const iconMap = {
        big: "🌹",
        small: "🌼",
        one: "🎆",
        two: "🎈",
      };

      return (this.lottery_peilv_list || []).map((item) => ({
        ...item,
        label: this.getDisplayName(item.name),
        icon: iconMap[item.type] || "🎯",
      }));
    },
    liveFeedRows() {
      const fallback = this.$t("reservation.no_choose");
      return (this.lottery_list || []).slice(0, 8).map((item) => {
        return `${item.expect} ${this.formatHistoryResult(item) || fallback}`;
      });
    },
    liveFeedLoopRows() {
      if (this.liveFeedRows.length <= 1) {
        return this.liveFeedRows;
      }
      return this.liveFeedRows.concat(this.liveFeedRows);
    },
    liveTrackStyle() {
      const rowCount = this.liveFeedRows.length || 1;
      return {
        "--live-row-count": rowCount,
        "--live-duration": `${Math.max(rowCount * 2.6, 8)}s`,
      };
    },
    hasSelection() {
      return this.formData.length > 0;
    },
    uiText() {
      const lang = this.$t("auth.lang");
      const copy = {
        zh: {
          history: "历史",
          liveBoard: "观看直播投票",
          optionTitle: "投票选项",
          linkedActivity: "关联活动",
          point: "点",
          select: "选择",
        },
        en: {
          history: "History",
          liveBoard: "Live Vote Feed",
          optionTitle: "Voting Options",
          linkedActivity: "Linked Activity",
          point: "Point",
          select: "Selected",
        },
        ja: {
          history: "履歴",
          liveBoard: "ライブ投票",
          optionTitle: "投票オプション",
          linkedActivity: "関連イベント",
          point: "点",
          select: "選択",
        },
        kr: {
          history: "기록",
          liveBoard: "실시간 투표",
          optionTitle: "투표 옵션",
          linkedActivity: "연결 활동",
          point: "점",
          select: "선택",
        },
      };

      return copy[lang] || copy.zh;
    },
    summaryText() {
      return `${this.formData.length}${this.$t("reservation.note")} ${this.totalAmount}${this.$t("reservation.unit")}`;
    },
    sheetSummaryText() {
      return `${this.uiText.select} ${this.formData.length} ${this.$t("reservation.note")} ${this.totalAmount} ${this.uiText.point}`;
    },
    totalAmount() {
      const amount = Number(this.money || 0) * this.formData.length;
      return Number.isNaN(amount) ? 0 : amount;
    },
    totalText() {
      return `${this.$t("reservation.total")} ${this.formData.length}${this.$t("reservation.note")}`;
    },
    historyToggleText() {
      return this.uiText.history;
    },
    liveBoardTitle() {
      return this.uiText.liveBoard;
    },
    unitText() {
      return `${this.$t("reservation.unit")}:`;
    },
    pointText() {
      return `${this.uiText.point}:`;
    },
    sheetPillText() {
      return this.formData.length
          ? `${this.formData.length}${this.$t("reservation.note")}`
          : this.$t("reservation.unit");
    },
  },
  methods: {
    back() {
      window.history.back();
    },
    getTypeByName(name) {
      const typeMap = {
        big: "big",
        small: "small",
        one: "one",
        two: "two",
        [this.rose]: "big",
        [this.lily]: "small",
        [this.fireworks]: "one",
        [this.balloon]: "two",
      };

      return typeMap[name] || name;
    },
    getDisplayName(name) {
      const displayMap = {
        big: this.rose,
        small: this.lily,
        one: this.fireworks,
        two: this.balloon,
      };

      return displayMap[name] || displayMap[this.getTypeByName(name)] || name;
    },
    formatHistoryResult(item) {
      if (!item || !item.opencode || item.opencode.length < 3) {
        return "";
      }
      const total = item.opencode[0] + item.opencode[1] + item.opencode[2];
      const sizeText = total >= 11 && total <= 18 ? this.rose : this.lily;
      const parityText = total % 2 === 0 ? this.balloon : this.fireworks;
      return `${sizeText} ${parityText}`;
    },
    updateSelections() {
      if (this.formData.length >= 1) {
        this.shopchoose = this.formData.map((item) => item.name).join(",");
        this.gameitem = this.formData.map((item) => item.type).join(",");
      } else {
        this.shopchoose = "";
        this.gameitem = "";
        this.shopping = false;
      }
    },
    doSub() {
      if (this.money === "0") {
        this.$toast(this.$t("reservation.money_err"));
        return false;
      }
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      }
      if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      }
      if (this.userInfo.money - this.money * this.formData.length < 0) {
        this.$toast(this.$t("reservation.balance_enough"));
        return false;
      }

      this.$http({
        method: "post",
        data: {
          item: this.gameitem,
          money: this.money,
          lid: this.lottery.id,
          mid: this.userInfo.id,
          expect: this.lottery.now_expect,
        },
        url: "game_place_order",
      }).then((res) => {
        if (res.code === 200) {
          this.$toast(res.msg);
          this.allClear();
          this.getUserInfo();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
      return true;
    },
    allClear() {
      for (var i = 0; i < this.formData.length; i++) {
        this.choose[this.formData[i].type] = false;
      }
      this.formData = [];
      this.money = "";
      this.updateSelections();
      this.jiesuanpage = false;
    },
    showRight() {
      this.showModel = true;
    },
    jiesuan() {
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      }
      if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      }
      this.jiesuanpage = !this.jiesuanpage;
      return true;
    },
    clearChooes(type) {
      for (var i = 0; i < this.formData.length; i++) {
        if (type === this.formData[i].type) {
          this.formData.splice(i, 1);
          this.choose[type] = false;
          break;
        }
      }
      this.updateSelections();
      if (this.formData.length === 0) {
        this.jiesuanpage = false;
      }
    },
    choosePlay(type, name) {
      if (this.choose[type]) {
        this.choose[type] = false;
        for (var i = 0; i < this.formData.length; i++) {
          if (type === this.formData[i].type) {
            this.formData.splice(i, 1);
            break;
          }
        }
      } else {
        this.formData.push({ name: name, type: type });
        this.choose[type] = true;
      }

      if (this.formData.length === 1) {
        this.shopping = true;
      }
      this.updateSelections();
    },
    check() {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
        return;
      }

      time = window.setInterval(() => {
        setTimeout(() => {
          this.getUserInfo();
          this.getLotteryInfo();
          this.getLotteryList();
          count++;
          if (count > 5) {
            clearInterval(time);
            count = 0;
          }
        }, 0);
      }, 300);
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryPeilv() {
      this.$http({
        method: "get",
        data: { id: this.ids },
        url: "lottery_get_peilv",
      }).then((res) => {
        if (res.code === 200) {
          this.lottery_peilv_list = Array.isArray(res.data) ? res.data : [];
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryList() {
      this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_one_list",
      }).then((res) => {
        if (res.code === 200) {
          this.lottery_list = Array.isArray(res.data) ? res.data : [];
          this.getLotteryPeilv();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getGameItem() {
      this.$http({
        method: "get",
        url: "lottery_list",
      }).then((res) => {
        this.gameitemData = Array.isArray(res.data) ? res.data : [];
      });
    },
    tabList(id, key) {
      this.ids = id;
      this.keys = key;
      this.showModel = false;
      this.getUserInfo();
      this.getGameItem();
      this.getLotteryInfo();
      this.getLotteryList();
    },
    getLotteryInfo() {
      this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_info",
      }).then((res) => {
        const lanng = this.$t("auth.lang");
        if (res.code === 200) {
          if (parseFloat(this.userInfo.money) < parseFloat(res.data.condition)) {
            this.$toast(this.$t("reservation.contact_admin"));
            this.$router.push({ path: "/Home" });
            return false;
          }

          this.lottery = res.data;
          this.time = res.data.second * 1000;

          if (lanng == "en") {
            this.lottery.name = res.data.name_es;
          }
          if (lanng == "ja") {
            this.lottery.name = res.data.name_ja;
          }
          if (lanng == "kr") {
            this.lottery.name = res.data.name_kr;
          }
          if (this.time / 1000 === 59) {
            this.$toast(this.$t("reservation.prize_succ") + this.lottery.now_expect);
          }

          this.sum = res.data.opencode[0] + res.data.opencode[1] + res.data.opencode[2];
          if (this.sum >= 11 && this.sum <= 18) {
            lanng == "zh"
                ? (this.size = "玫瑰")
                : lanng == "en"
                    ? (this.size = "Rose")
                    : lanng == "ja"
                        ? (this.size = "バラは")
                        : (this.size = "장미");
          } else if (this.sum >= 3 && this.sum <= 10) {
            lanng == "zh"
                ? (this.size = "百合")
                : lanng == "en"
                    ? (this.size = "Lily")
                    : lanng == "ja"
                        ? (this.size = "リリー·リリー")
                        : (this.size = "백합");
          }
          if (this.sum % 2 === 0) {
            lanng == "zh"
                ? (this.double = "氣球")
                : lanng == "en"
                    ? (this.double = "Balloon")
                    : lanng == "ja"
                        ? (this.double = "气球")
                        : (this.double = "풍선");
          } else {
            lanng == "zh"
                ? (this.double = "煙花")
                : lanng == "en"
                    ? (this.double = "fireworks")
                    : lanng == "ja"
                        ? (this.double = "花火大会")
                        : (this.double = "불꽃놀이");
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
      this.getGameItem();
      this.getLotteryInfo();
      this.getLotteryList();
    }

    const lang = this.$t("auth.lang");
    if (lang == "zh") {
      this.rose = "玫瑰";
      this.lily = "百合";
      this.balloon = "氣球";
      this.fireworks = "煙花";
    } else if (lang == "en") {
      this.rose = "Rose";
      this.lily = "Lily";
      this.balloon = "Balloon";
      this.fireworks = "Fireworks";
    } else if (lang == "ja") {
      this.rose = "バラは";
      this.lily = "リリー·リリー";
      this.balloon = "气球";
      this.fireworks = "花火大会";
    } else {
      this.rose = "장미";
      this.lily = "백합";
      this.balloon = "풍선";
      this.fireworks = "불꽃놀이";
    }
  },
  destroyed() {
    clearInterval(time);
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.lottery-page {
  min-height: 100vh;
  padding-bottom: 300px;
  background: #fff8fa;
}

.nav-bar {
  background: #ff6f97;
  position: relative;
  z-index: 6;
}

.nav-bar ::v-deep .van-nav-bar__title,
.nav-bar ::v-deep .van-icon {
  color: #fff;
}

.page-body {
  padding: 24px 18px 0;
  position: relative;
  z-index: 3;
}

.hero-wrap {
  position: relative;
  z-index: 5;
}

.hero-wrap::after {
  content: "";
  position: absolute;
  left: -18px;
  right: -18px;
  top: -24px;
  height: calc(100% + 24px);
  background: #fff8fa;
  z-index: 4;
}

.hero-card {
  padding: 22px 18px 18px;
  border-radius: 18px 18px 0 0;
  background: linear-gradient(270deg, #ff516b, #f898a5);
  color: #fff;
  position: relative;
  z-index: 7;
  height: 300px;
}

.hero-card.expanded {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.hero-top,
.hero-bottom,
.hero-history-toggle,
.option-card,
.selection-summary,
.sheet-row,
.live-row,
.menu-card {
  display: flex;
  align-items: center;
}

.hero-top {
  justify-content: space-between;
}

.hero-status,
.hero-expect,
.hero-label,
.hero-result-title {
  margin: 0;
}

.hero-status {
  font-size: 22px;
  opacity: 0.9;
}

.hero-expect {
  margin-top: 12px;
  font-size: 26px;
  font-weight: 700;
  line-height: 1;
}

.hero-menu {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border: 1px solid rgba(255, 255, 255, 0.38);
  border-radius: 12px;
  font-size: 28px;
  background: rgba(255, 255, 255, 0.08);
}

.hero-countdown {
  display: inline-flex;
  margin-top: 20px;
  padding: 10px 14px;
  border: 1px solid rgba(255, 255, 255, 0.42);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
}

.hero-countdown ::v-deep .van-count-down {
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}

.hero-bottom {
  justify-content: space-between;
  margin-top: 80px;
  font-size: 20px;
}

.hero-result {
  display: flex;
  gap: 6px;
  align-items: center;
  opacity: 0.92;
}

.hero-history-toggle {
  gap: 4px;
  font-size: 24px;
}

.history-dropdown {
  position: absolute;
  top: 100%;
  left: -18px;
  right: -18px;
  overflow: hidden;
  height: 55vh;
  border-radius: 0;
  background: #fff;
  border: 1px solid #f3d9e2;
  border-top: none;
  box-shadow: 0 18px 32px rgba(51, 30, 37, 0.14);
  z-index: 6;
  padding: 30px 20px;

}

.history-head,
.history-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px;
}

.history-head {
  height: 56px;
  font-size: 24px;
  font-weight: 700;
  color: #d88aa8;
  background: #fff7fa;
}

.history-list {
  height: calc(80vh - 56px);
  overflow-y: auto;
}

.history-item {
  min-height: 54px;
  font-size: 20px;
  color: #d58ba6;
}

.history-item:nth-child(2n) {
  background: #fffafb;
}

.history-drop-enter-active,
.history-drop-leave-active {
  transition: all 0.2s ease;
}

.history-drop-enter,
.history-drop-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.page-mask {
  position: fixed;
  inset: 0;
  background: rgba(34, 20, 26, 0.36);
  z-index: 2;
}

.mask-fade-enter-active,
.mask-fade-leave-active {
  transition: opacity 0.2s ease;
}

.mask-fade-enter,
.mask-fade-leave-to {
  opacity: 0;
}

.section-block {
  margin-top: 24px;
}

.section-title {
  position: relative;
  margin-bottom: 18px;
  padding-left: 12px;
  font-size: 28px;
  font-weight: 700;
  color: #444;
}

.section-title::before {
  content: "";
  position: absolute;
  left: 0;
  top: 4px;
  width: 4px;
  height: 18px;
  border-radius: 999px;
  background: #ef7aa3;
}

.option-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.option-card {
  min-height: 152px;
  padding: 0 20px;
  justify-content: space-between;
  border: 2px solid #f1edf0;
  border-radius: 16px;
  background: #fff;
  //margin: auto;
  text-align: center;
}

.option-card.active {
  border-color: #3a9df8;
  background: #37a0ff;
}

.option-card.active .option-name,
.option-card.active .option-odd,
.option-card.active .option-icon {
  color: #fff;
}

.option-icon {
  font-size: 48px;
  text-align: center;
}

.option-name {
  flex: 1;
  margin-left: 12px;
  font-size: 26px;
  color: #4d4d4d;
}

.option-odd {
  font-size: 24px;
  font-weight: 700;
  color: #f26b8e;
}

.live-board {
  margin-top: 100px;
  overflow: hidden;
  border-radius: 18px;
  background: #fff;
  border: 1px solid #f1d8e0;
}

.live-header {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  background: #eba0bb;
  font-size: 24px;
  font-weight: 700;
  color: #fff;
}

.live-content {
  height: 420px;
  overflow: hidden;
}

.live-row {
  height: 80px;
  padding: 0 18px;
  font-size: 24px;
  color: #6b6b6b;
}

.live-track {
  animation: none;
}

.live-track.scrolling {
  animation: live-scroll var(--live-duration) linear infinite;
}

.live-row:nth-child(2n) {
  background: #f7f7f7;
}

.history-expect {
  font-size: 24px;
  font-weight: 700;
}

.history-result {
  margin-left: 16px;
  text-align: right;
  font-size: 24px;
  padding-right: 100px;
}

.bottom-sheet {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  padding: 22px 24px calc(env(safe-area-inset-bottom) + 28px);
  border-radius: 28px 28px 0 0;
  background: #fff;
  border-top: 1px solid #f0d9e1;
  box-shadow: 0 -8px 24px rgba(63, 36, 45, 0.08);
}

.selection-summary {
  font-size: 26px;
  font-weight: 500;
  color: #d38ca7;
  line-height: 1.2;
  text-align: left;
}

.sheet-panel {
  margin-top: 28px;
}

.sheet-row {
  align-items: center;
  justify-content: center;
  min-height: 96px;
}

.sheet-row + .sheet-row {
  margin-top: 12px;
}

.sheet-label {
  flex-shrink: 0;
  margin-right: 18px;
  font-size: 24px;
  font-weight: 700;
  color: #d38ca7;
}

.sheet-input-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 72%;
  max-width: 420px;
}

.sheet-input {
  width: 0;
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  height: 72px;
  padding: 0 18px;
  border-radius: 36px;
  background: #f4f4f6;
}

.sheet-unit-pill {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  height: 72px;
  padding: 0 20px;
  border-radius: 36px;
  background: #f4f4f6;
  font-size: 24px;
  color: #b4a6ad;
}

.sheet-input ::v-deep .van-cell {
  padding: 0;
  background: transparent;
}

.sheet-input ::v-deep .van-field__control::placeholder {
  color: #c7b7bf;
}

.sheet-input ::v-deep input {
  font-size: 26px;
  text-align: center;
}

.bottom-submit {
  margin: 28px auto 0;
  height: 72px;
  line-height: 72px;
  border-radius: 12px;
  background: #e79bb6;
  font-size: 28px;
  font-weight: 700;
  text-align: center;
  color: #fff;
  width: 80%;
}

.confirm-popup {
  width: 88%;
  border-radius: 18px;
}

.confirm-order-modal {
  overflow: hidden;
  border-radius: 18px;
  background: #fff;
}

.head {
  padding: 16px;
  background: #ea98b4;
}

.head .text {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  color: #fff;
}

.list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.lise-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
}

.bet-name {
  margin: 0 0 6px;
  font-size: 20px;
  font-weight: 700;
  color: #ef6a97;
}

.detail-text {
  margin: 0;
  font-size: 17px;
  color: #82616d;
}

.sub-bar {
  display: flex;
  gap: 12px;
  padding: 16px;
}

.sub-bar .item {
  flex: 1;
  height: 42px;
  border-radius: 10px;
}

.cancel-btn {
  color: #7e6b73;
  background: #f4eff1;
  border: none;
}

.sub-btn {
  color: #fff;
  background: #ea98b4;
  border: none;
}

.menu-popup {
  width: 70%;
  height: 100%;
}

.menu-list {
  height: 100%;
  padding: 18px 14px;
  overflow-y: auto;
  background: #fff7fa;
}

.menu-item + .menu-item {
  margin-top: 12px;
}

.menu-item {
  padding: 14px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid #f0dbe3;
}

.menu-tag {
  font-size: 18px;
  color: #d28ca6;
}

.menu-card {
  justify-content: center;
  width: 64px;
  height: 64px;
  margin-top: 12px;
  border-radius: 12px;
  background: #fff6f8;
}

.menu-name {
  margin-top: 10px;
  font-size: 20px;
  font-weight: 700;
  color: #4b4346;
}

.down {
  transition: transform 0.3s ease;
}

.up {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}

@keyframes live-scroll {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(calc(-52px * var(--live-row-count)));
  }
}
</style>
